import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { RecoveryButton } from './RecoveryButton';
interface NavbarProps {
  onEstimate: () => void;
}
export function Navbar({
  onEstimate
}: NavbarProps) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${scrolled ? 'border-b border-ink/10 bg-cream/90 backdrop-blur' : 'bg-transparent'}`} data-id="element-1928" data-mp="kekfxm6qurs">
      <nav className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-5 py-4 sm:px-8" data-id="element-1929" data-mp="9jrtip6edhbz">
        <Link to="/" className="block" aria-label="ManyCo.ai home" data-id="element-1930" data-mp="1pxrtu195n8zr">
          <img src="https://cdn.magicpatterns.com/uploads/oywoASH6Re9P4rztZheujv/ManyCo_ai.svg" alt="ManyCo.ai" className="h-7 w-auto sm:h-8" data-id="element-1931" data-mp="1kzgjzqiv0yhj" />
        </Link>
        <div className="flex items-center gap-3 sm:gap-5" data-id="element-1932" data-mp="enkeebaq05kp">
          <Link to="/signin" className="whitespace-nowrap text-sm font-medium text-ink/70 transition-colors hover:text-ink" data-id="element-1933" data-mp="elzkmnw8cqnw">
            Sign in
          </Link>
          <RecoveryButton onClick={onEstimate} className="rounded-full bg-forest px-4 py-2.5 text-sm font-semibold text-cream transition-colors hover:bg-forest-dark sm:px-5" data-id="element-1934" data-mp="om07gjtb5owu" />
        </div>
      </nav>
    </header>;
}